export interface HdmgdjNavItem {
  id: string;
  label: string;
}

/** 页首页尾共用的模块锚点：点击即时定位到该板块最上方，与屏幕顶部重叠 */
export const hdmgdjSections: HdmgdjNavItem[] = [
  { id: "hdmgdj-top", label: "首页" },
  { id: "hdmgdj-shots", label: "软件截图" },
  { id: "hdmgdj-features", label: "功能特色" },
  { id: "hdmgdj-genres", label: "剧集题材" },
  { id: "hdmgdj-ranking", label: "热门榜单" },
  { id: "hdmgdj-faq", label: "常见问题" },
];